// Spray API endpoints
export const AREA_API = '/api/sprays/areas/';
export const SURFACE_UNIT_API = AREA_API; // Alias for backwards compatibility
export const MASS_UNIT_API = '/api/sprays/mass-units/';
export const SPACING_WIDTH_TYPE_API = '/api/sprays/spacing-width-types/';
export const MEASUREMENT_UNIT_API = '/api/sprays/measurement-units/';
export const LIQUID_VOLUME_UNIT_API = '/api/sprays/liquid-volume-units/';
export const WATER_VOLUME_PER_AREA_API = '/api/sprays/water-volume-per-areas/';
export const PRODUCT_DOSE_API = '/api/sprays/product-doses/';

// Unit form options
export const UNIT_FORM_OPTIONS = [
    {value: 'liquid', label: 'Liquid'},
    {value: 'solid', label: 'Solid'},
];

// Dose type options
export const DOSE_TYPE_OPTIONS = [
    {value: 'surface', label: 'Dose by Surface Area'},
    {value: 'water_quantity', label: 'Dose by Water Quantity'},
    {value: 'vv_percentage', label: 'Dose by % v/v'},
];
